import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET, POST } from "../../helpers/apiHelper";
import * as action from "./actions";

export const getListState = (state) => state.logApp.list;
export const getListImportState = (state) => state.logApp.list_import;

const loadLogAsync = async (query) => GET(`/log?${query}`);
const storeLogAsync = async (item) => POST(`/log/master/store`, item, { idempotent: true });
const storeLogSchedulerAsync = async (item, query) => POST(`/log/scheduler/store?${query}`, item);
const loadLogSyncAsync = async (query) => GET(`/log/sync?${query}`);

/**
 * Saga to load logs list.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Payload containing query/filter parameters.
 */
function* loadLogList({ payload }) {
  try {
    const list = yield select(getListState);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "orderby",
        value: list.orderBy,
      },
      {
        name: "sortedby",
        value: list.sortedBy,
      },
      {
        name: "limit",
        value: payload.limit,
      }, 
      {
        name: "municipal_id",
        value: encodeURIComponent(payload?.municipal_id),
      },
      {
        name: "title",
        value: payload.title,
      },
      {
        name: "schedule_job_id",
        value: payload.scheduleJobId,
      },
      {
        name: "importType",
        value: payload.importType,
      }
    ];

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
        ],
      ];
    }
 
  //console.log(param.map((t) => `${t.name}=${t.value}`).join("&"))    
    let response = null;
    if(payload.section === 'SCHEDULER'){
      response = yield call(
        loadLogAsync,
        param.map((t) => `${t.name}=${t.value}`).join("&")
      );
    }else{
      response = yield call(
        loadLogSyncAsync,
        param.map((t) => `${t.name}=${t.value}`).join("&")
      );
    }
    yield put(action.loadLogSuccess(response));
  } catch (error) {
    console.log('[loadLogList] error', error)
    // yield call(unauthorizeUser(error));
    yield put(action.loadLogError(error));
  }
}

/**
 * Saga to save a log entry.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Log entry data to be saved.
 */
function* saveLog({ payload }) {
  try {
    if (payload.item) {
      yield call(storeLogAsync, payload.item);
    } else {
      throw new Error("invalid save item, cannot be null");
    }
  } catch (error) {
    //console.log(error);
  }
}

/**
 * Saga to save a log entry related to a scheduler.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Log entry data with optional scheduler query info.
 */
function* saveLogScheduler({ payload }) {
  try {
    if (payload.item) {
      yield call(storeLogSchedulerAsync, payload.item, payload?.query);
    } else {
      throw new Error("invalid save item, cannot be null");
    }
  } catch (error) {
    //console.log(error);
  }
}

/**
 * Watcher saga.
 *
 */
export function* watchLoadLogList() {
  yield takeEvery(action.LOG_GET_LIST, loadLogList);
}

export function* watchStoreLogList() {
  yield takeEvery(action.LOG_STORE, saveLog);
}

export function* watchStoreLogSchedulerList() {
  yield takeEvery(action.LOG_STORE_SCHEDULER, saveLogScheduler);
}

/**
 * Root saga for all filter-related actions.
 *
 * @generator
 */
export default function* rootSaga() {
  yield all([
    fork(watchLoadLogList),
    fork(watchStoreLogList),
    fork(watchStoreLogSchedulerList),
  ]);

}
